import { http } from '../axios';
import { shopPrefix } from '../../config';
import { LineItemKey, ProductFilter } from '../../store/api';
import { SubscriptionPeriodType } from '../../../models/Article';

export type ChangeSubscriptionPeriodByFilterCartRequest = {
    filterRequest: ProductFilter;
    excludedLineItemKeys: LineItemKey[];
    subscriptionPeriodType: SubscriptionPeriodType;
};

type Options = {
    body: ChangeSubscriptionPeriodByFilterCartRequest;
};

const url = `${shopPrefix}/v2/shoppingcart/bulk/filter/changeSubscriptionPeriod`;

export const bulkChangeSubscriptionPeriodByFilter = ({ body }: Options) => {
    return http.put<void>(url, body).then(res => res.data);
};
